var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ShopView',[_c('h1',{staticClass:"mb-6 d-flex align-center"},[_vm._v(" "+_vm._s(_vm.$t('pageTitles.shop.faq'))+" ")]),_c('AsiCard',{attrs:{"unwrapped":""}},[_c('v-card-text',{staticClass:"pa-6"},[_c('Faqs')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }